
const displayIfExist = (data) => {
    if (data){
        return data;
    }
    else{
        return "";
    }
}

export const transformPayrollName = (name) => { 
    if (name !== "" && name !== undefined){
        const transform1 = name.replaceAll("_", " ");
        const transform2 = transform1.replaceAll("BI MONTHLY", "BI-MONTHLY");
        
        const array = transform2.split(" ");
        // const transform3 = array[0] + " " + array[1] + " - " + array[2] + ", " + array[3] + (array[4] ? " - " : "") + displayIfExist(array[4]) + " " + displayIfExist(array[5]) + " " + displayIfExist(array[6]);
        const transform3 = `${array[0]} ${array[1]} ${array[2] ? `- ${array[2]}` : ""}${array[3] ? `, ${array[3]}` : ""} ${array[4] ? " - " : ""} ${displayIfExist(array[4])} ${displayIfExist(array[5])} ${displayIfExist(array[6])}`;
        
        return transform3;
    }
    else{
        return name;
    }
};

